import { render, staticRenderFns } from "./VesselDetails.vue?vue&type=template&id=13afcb12&scoped=true&"
import script from "./VesselDetails.vue?vue&type=script&lang=js&"
export * from "./VesselDetails.vue?vue&type=script&lang=js&"
import style0 from "./VesselDetails.vue?vue&type=style&index=0&id=13afcb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afcb12",
  null
  
)

export default component.exports